import React from 'react';
import styled from 'styled-components';

interface Props {
  active: boolean;
}

const size = 14;

const Track = styled.div<{ active: boolean }>`
  width: calc(${size * 2}px + 4px);
  height: ${size + 4}px;
  border-radius: 9999px;
  background-color: ${({ active }) => (active ? '#007AFF' : '#C8C8CA')};
  position: relative;
  flex-shrink: 0;
  transition: background-color 200ms ease;
`;

const Thumb = styled.div<{ active: boolean }>`
  position: absolute;
  top: 2px;
  left: 2px;
  width: ${size}px;
  height: ${size}px;
  border-radius: 50%;
  background: #ffffff;
  box-shadow:
    0 3px 8px rgba(0, 0, 0, 0.15),
    0 1px 1px rgba(0, 0, 0, 0.16);
  transform: ${({ active }) => (active ? `translateX(${size}px)` : 'translateX(0)')};
  transition: transform 200ms ease;
`;

export const ToggleSwitch = ({ active }: Props) => (
  <Track active={active}>
    <Thumb active={active} />
  </Track>
);
